import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Layout from "components/LayoutContainers/mainLayout";
import { useIsMobile } from "hooks/mobileCheck/useCheckMobile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function MobileHome() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isSuccess = queryParams.get("success") === "true";

  if (!isMobile) {
    return (
      <Layout>
        <MDBox p={3} textAlign="center">
          <MDTypography variant="h4" color="error">
            Esta página está disponível apenas para dispositivos móveis.
          </MDTypography>
        </MDBox>
      </Layout>
    );
  }

  return (
    <Layout>
      <MDBox pt={3} pb={3} px={2}>
        <Grid container spacing={3} justifyContent="center">
          {isSuccess && (
            <Grid item xs={12} mb={3}>
              <Card>
                <MDBox p={3} textAlign="center">
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="64px"
                    height="64px"
                    bgColor="success"
                    color="white"
                    shadow="md"
                    borderRadius="50%"
                    mx="auto"
                    mb={2}
                  >
                    <CheckCircleIcon fontSize="large" />
                  </MDBox>
                  <MDTypography variant="h5" color="success" fontWeight="bold">
                    Sucesso!
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    Reporte feito com sucesso.
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          )}

          <Grid item xs={12}>
            <Card>
              {/* <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                textAlign="center"
              >
                <MDTypography variant="h4" color="white" fontWeight="medium">
                  Bem-vindo ao Portal Mobile
                </MDTypography>
              </MDBox> */}
              <MDBox p={3} textAlign="center">
                <MDTypography variant="body2" color="text" mb={3}>
                  Use o botão abaixo para reportar um novo evento de segurança de forma rápida.
                </MDTypography>

                <MDButton
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="large"
                  onClick={() => navigate("/reportar")}
                  startIcon={<Icon>edit</Icon>}
                >
                  Reportar Novo Evento
                </MDButton>
              </MDBox>
            </Card>
          </Grid>

        </Grid>
      </MDBox>
    </Layout>
  );
}

export default MobileHome;
